import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { CellRendererParams } from './types';

export const TeamMembersRenderer: FC<CellRendererParams> = ({
  value,
  data,
}) => (
  <FormattedMessage
    id="partners.list.columns.team_members.content"
    values={{ count: value ?? 1, totalSeats: data.maxSeat ?? value ?? 1 }}
  />
);
